<script setup lang="ts">
import Auth from '@/api/Auth'
import CompleteYourProfileModal from '@/components/common/auth/CompleteYourProfileModal.vue'
import useAuthStore from '@/stores/auth'
import { useDialog, useToast } from 'lilasia-ui'
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const { showDialog } = useDialog()
const { toastError } = useToast()
const route = useRoute()
const authStore = useAuthStore()

watch(
  () => authStore.showCompleteYourProfileModal,
  (newState) => {
    if (newState) {
      showCompleteProfileModal()
    }
  }
)

onMounted(() => {
  verifyEmail()
})

const verifyEmail = async () => {
  if (route.query['verify-email']) {
    try {
      await Auth.verifyEmail()
    } catch (error) {
      const fetchError = error as FetchError
      toastError(fetchError.message)
    }
  }
}

const showCompleteProfileModal = () => {
  showDialog(CompleteYourProfileModal)
  authStore.showCompleteYourProfileModal = false
}
</script>

<template>
  <div class="hidden"></div>
</template>
